import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import OffersSection from '../components/OffersSection';
import AboutUs from '../components/AboutUs';
import GuidesSection from '../components/GuidesSection';
import FAQ from '../components/FAQ';
import NewsSection from '../components/NewsSection';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <OffersSection />
      <AboutUs />
      <GuidesSection />
      <FAQ />
      <NewsSection />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default Home;

